export default __webpack_public_path__ + "static/media/cockpit-system.b4c533d3.jpg";